import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgBodyEar = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.125 7C10.3458 5.92841 10.886 4.94883 11.6744 4.1902C12.4628 3.43157 13.4624 2.92947 14.5417 2.75C15.3637 2.57046 16.2156 2.5774 17.0346 2.77033C17.8536 2.96325 18.619 3.33725 19.2744 3.86483C19.9299 4.39242 20.4589 5.06018 20.8224 5.81904C21.1859 6.5779 21.3747 7.40857 21.375 8.25C21.3785 9.22058 21.1687 10.1801 20.7604 11.0606C20.3522 11.9412 19.7555 12.7213 19.0125 13.3458C18.5171 13.6688 18.1211 14.1231 17.8688 14.6579C17.6164 15.1928 17.5176 15.7873 17.5833 16.375C17.6448 17.0455 17.632 17.7207 17.545 18.3883C17.3546 19.2955 16.8349 20.0999 16.0863 20.6465C15.3378 21.1931 14.4133 21.4431 13.4912 21.3482C12.5692 21.2534 11.715 20.8204 11.0933 20.1328C10.4717 19.4453 10.1268 18.5519 10.125 17.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7849 8.39168C12.8183 8.08985 12.9114 7.79768 13.0587 7.53213C13.206 7.26658 13.4046 7.03295 13.643 6.84482C13.8813 6.6567 14.1547 6.51782 14.4472 6.43627C14.7397 6.35472 15.0455 6.33211 15.3469 6.36977C15.6482 6.40743 15.939 6.5046 16.2025 6.65563C16.4659 6.80667 16.6967 7.00856 16.8815 7.24956C17.0662 7.49057 17.2012 7.76589 17.2786 8.05952C17.356 8.35316 17.3743 8.65925 17.3324 8.96001"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 11.375H3.875L5.75 8.875L7.625 13.875L10.125 11.375H11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgBodyEar.displayName = 'SvgBodyEar';
export default SvgBodyEar;
